import React from "react";
import Navbar from "../components/Navbar";
import SecondaryHero from "../components/SecondaryHero";
import PrivacyPolicy from "../components/PrivacyPolicy";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet-async"; // ✅ Added Helmet import

const Privacy = () => {
  return (
    <>
      {/* ✅ SEO + Tab Title */}
      <Helmet>
        <title>Privacy Policy | VisionBird Technologies</title>
        <meta
          name="description"
          content="Learn how VisionBird Technologies collects, uses, and safeguards your personal information. Read our privacy policy to understand your rights and our commitment to security."
        />
      </Helmet>

      <Navbar />
      <SecondaryHero
        title="Privacy"
        highlight="Policy"
        description={`VisionBird Technologies ("Company", "we", "our", "us") respects your privacy and values your trust. 
              This Privacy Policy explains how we collect, use, store, and safeguard your information when you visit 
              our website, apply for a job/internship, or communicate with us.`}
        image="/assets/Images/Privacy policy-pana 1.png"
      />
      <PrivacyPolicy />
      <Footer />
    </>
  );
};

export default Privacy;